module.exports = __webpack_public_path__ + "img/floating-booking.16e487b0.svg";